import { Drawer, Button } from '@mui/material';
import IcClose from '../../assets/image/ic_x.svg';
import RecordingGuideCarousel from './RecordingGuideCarousel';
import { useTranslation } from '../../hook/useTranslation';

function RecordingGuideDialog({ open, onClose = () => {}, onConfirm = () => {} }) {
  const { t } = useTranslation();
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick') return;
        if (onClose) (onClose as any)(event, reason);
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0', minHeight: '80vh' } }}
    >
      <div className="w-full p-5 min-h-[200px] text-[#1C1C1C] font-['Pretendard'] flex flex-col items-center justify-between bg-white overflow-hidden h-full">
        <div className="w-full flex justify-between items-center mb-3 absolute top-5 left-0 px-5 z-[9999]">
          <div className="w-[24px]" />
          <div className="w-full text-[#1C1C1C] text-[18px] text-center font-[600]">{t('upload.guide.title')}</div>
          <button
            type="button"
            onClick={onClose}
            className="w-[24px] h-[24px] flex items-center justify-center"
          >
            <img src={IcClose} alt="Close" />
          </button>
        </div>
        <div className="w-full flex flex-col justify-start items-start grow mt-[36px] overflow-y-auto">
          <div className="text-[28px] font-[800] text-['Pretendard'] mt-[20px]">
            {t('upload.guide.intro_line1')}
            <br />
            {t('upload.guide.intro_line2')}
          </div>
          <div className="text-[#363636] text-[14px] font-[400] mt-3">
            {t('upload.guide.desc_line1')}
            <br />
            {t('upload.guide.desc_line2')}
          </div>
          <div className="w-full flex justify-center items-center my-[28px]">
            <RecordingGuideCarousel />
          </div>
          <div className="w-full px-[12px] h-[76px] bg-[#F8F8F8] rounded-[16px] text-[#333] flex items-center justify-center gap-3 shrink-0 mb-[36px]">
            <div className="w-[44px] h-[44px] bg-[#fff] rounded-[100px] flex items-center justify-center border border-[#EAEAEA] shrink-0">
              <div className="text-[14px] font-[700] text-[#5EBEBB]">{t('upload.guide.tip')}</div>
            </div>
            <div className="flex flex-col gap-1 w-full justify-center shrink-1">
              <div className="text-[14px]">{t('upload.guide.tip_desc1')}</div>
              <div className="text-[14px]">{t('upload.guide.tip_desc2')}</div>
            </div>
          </div>
        </div>
        <Button variant="contained" className="w-full" onClick={onConfirm}>
          {t('upload.caution.confirm_btn')}
        </Button>
      </div>
    </Drawer>
  );
}

export default RecordingGuideDialog;
